export const config = {
  propsName: 'renderProps',
  name: 'SpUploadImg',
  type: 'formTmpsConfig',
  icon: 'el-icon-picture-outline',
  cnName: '图片上传',
  tooltip: 'SpTmp模版tooltip',
  base: {
    title: '图片上传',
    padded: true,
    flex: '2',
    margin: [0, 0, 0, 0]
  },
  props: [
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      tooltip: '排列方式的tooltip',
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: null
    },

    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '图片上传名称',
        placeholder: '请输入名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'maxValueSize',
      bind: {
        label: '图片上传个数',
        placeholder: '1'
      },
      value: '1'
    }
  ]
}
